/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from "react";
import API from "../../utils/API";
import PropTypes from "prop-types";
import { Grid, Typography, Tab, Tabs, Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

import db from "../../db/db";
import PSelect from "../../components/pos/PSelect";
import PText from "../../components/pos/PText";
import PDialog from "../../components/pos/PDialog";
import PCheck from "../../components/pos/PCheck";
import { SyncUtils } from "../../utils/SyncUtils";
import PConfirm from "../../components/pos/PConfirm";
import { StringUtils } from "../../utils/StringUtils";
import PrintIcon from "@mui/icons-material/Print";
import CustomerTransactionList from "./customertransaction/CustomertransactionList";
function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && (
        <Box p={3}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default function CustomerCrud(props) {
  const { t } = useTranslation();
  const translate = t;
  const [value, setValue] = useState(0);
  const [origObject, setOrigObject] = useState(null);
  const [mode, setMode] = useState("create");
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitile] = useState("");
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [liveValidation, setLiveValidation] = useState(false);

  const [saleSettings, setSaleSettings] = useState(null);

  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [custId, setCustid] = useState("");
  const [custIdError, setCustidError] = useState("");
  const [micrCode, setMicrcode] = useState("AUTO");
  const [micrCodeError, setMicrcodeError] = useState("");
  const [address1, setAddress1] = useState("");
  const [address1Error, setAddress1Error] = useState("");
  const [state, setState] = useState("");
  const [stateError, setStateError] = useState("");
  const [customerGroup, setCustomergroup] = useState("");
  const [customerGroupError, setCustomergroupError] = useState("");
  const [customerGroupOptions, setCustomerGroupOptions] = useState("");
  const [street, setStreet] = useState("");
  const [streetError, setStreetError] = useState("");
  const [zip, setZip] = useState("");
  const [zipError, setZipError] = useState("");
  const [trn, setTrn] = useState("");
  const [trnError, setTrnError] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [creditCustomer, setCreditcustomer] = useState(false);
  const [creditLimit, setCreditlimit] = useState(0);
  const [creditLimitError, setCreditlimitError] = useState("");
  const [limitDays, setLimitDays] = useState(0);
  const [limitDaysError, setLimitDaysError] = useState("");
  const [taxRegistered, setTaxRegistered] = useState(false);
  const [openingDueAmount, setOpeningdueamount] = useState(0);
  const [openingDueAmountError, setOpeningdueamountError] = useState("");
  const [openingNature, setOpeningNature] = useState("");
  const [openingNatureError, setOpeningNatureError] = useState("");
  const [dob, setDob] = useState("");
  const [dobError, setDobError] = useState("");
  const [address2, setAddress2] = useState("");
  const [address2Error, setAddress2Error] = useState("");
  const [city, setCity] = useState("");
  const [cityError, setCityError] = useState("");

  const [secondCustomerName, setSecondcustomername] = useState("");
  const [secondCustomerNameError, setSecondcustomernameError] = useState("");
  const [thirdCustomerName, setThirdcustomername] = useState("");
  const [thirdCustomerNameError, setThirdcustomernameError] = useState("");
  const [fourthCustomerName, setFourthcustomername] = useState("");
  const [fourthCustomerNameError, setFourthcustomernameError] = useState("");
  const [anniversary, setAnniversary] = useState("");
  const [anniversaryError, setAnniversaryError] = useState("");
  const [country, setCountry] = useState("");
  const [countryError, setCountryError] = useState("");
  const [mobile, setMobile] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [emailInvoice, setEmailInvoice] = useState(false);
  const [emailInvoiceError, setEmailInvoiceError] = useState("");
  const [smsInvoice, setSmsInvoice] = useState(false);
  const [smaInvoice, setSmsInvoiceError] = useState("");
  const [secondCustomerContact, setSecondcustomercontact] = useState("");
  const [secondCustomerContactError, setSecondcustomercontactError] =
    useState("");
  const [fourthCustomerContact, setFourthCustomerContact] = useState("");
  const [fourthCustomerContactError, setFourthCustomerContactError] =
    useState("");
  const [thirdCustomerContact, setThirdcustomercontact] = useState("");
  const [thirdCustomerContactError, setThirdcustomercontactError] =
    useState("");
  const [pricingLevelOptions, setPricingLevelOptions] = useState([]);
  const [pricingLevel, setPricingLevel] = useState("");
  const [callFrom, setCallFrom] = useState("");
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");
  const [address, setAddress] = useState("");
  const [addressError, setAddressError] = useState("");
  /*CODEGEN_STATE_INIT ######## DO_NOT_REMOVE ###########*/

  props.biRef.child = {
    showCustomerCrudWindow: showCustomerCrudWindow,
  };

  useEffect(() => {
    loadCustomerGroups();
    loadPricingLevels();
    if(props.context.store.tradingMode){
      setCreditcustomer(true)
    }
    
  }, []);

  useEffect(() => {
    if (origObject) {
      setWindowTitile(origObject.name);
    }
  }, [origObject]);

  useEffect(() => {
    if (liveValidation && name === "")
      setNameError(translate("Name is Required"));
    else setNameError("");
  }, [name]);
  useEffect(() => {
    if (liveValidation && custId === "")
      setCustidError(translate("Customer Id is Required"));
    else setCustidError("");
  }, [custId]);
  useEffect(() => {
    if (liveValidation && micrCode === "")
      setMicrcodeError(translate("Micr code is Required"));
    else setMicrcodeError("");
  }, [micrCode]);
  useEffect(() => {
    if (liveValidation && address1 === "")
      setAddress1Error(translate("Address1 is Required"));
    else setAddress1Error("");
  }, [address1]);

  useEffect(() => {
    if (liveValidation && phone === "")
      setPhoneError(translate("Phone is Required"));
    else setPhoneError("");
  }, [phone]);
  useEffect(() => {
    if (liveValidation && mobile === "")
      setMobileError(translate("Mobile Number is Required"));
    else setMobileError("");
  }, [mobile]);
  useEffect(() => {
    if (liveValidation && email === "" && emailInvoice)
      setEmailError(translate("Email Id Required"));
    else setEmailError("");
  }, [email]);
  useEffect(() => {
    if (liveValidation && emailInvoice && email === "")
      setEmailError(translate("Email Id Required"));
    else setEmailError("");
  }, [emailInvoice]);
  useEffect(() => {
    if (liveValidation && trn === "" && taxRegistered)
      setTrnError(translate("Trn Required"));
    else if (taxRegistered && trn != "" && trn.length != 15) {
      setTrnError(translate("Length should be 15"));
    } else setTrnError("");
  }, [trn]);
  useEffect(() => {
    if (liveValidation && taxRegistered && trn === "")
      setTrnError(translate("Trn Required"));
    else setTrnError("");
  }, [taxRegistered]);
  useEffect(() => {
    if (liveValidation && openingDueAmount > 0 && openingNature === "")
      setOpeningNatureError(translate("Opening nature Required"));
    else setOpeningNatureError("");
  }, [openingNature]);

  /*useEffect(() => {
    if (liveValidation && state === "") setStateError("State is Required");
    else setStateError("");
  }, [state]);
  useEffect(() => {
    if (liveValidation && customerGroup === "")
      setCustomergroupError("Customergroup is Required");
    else setCustomergroupError("");
  }, [customerGroup]);
  useEffect(() => {
    if (liveValidation && street === "") setStreetError("Street is Required");
    else setStreetError("");
  }, [street]);
  useEffect(() => {
    if (liveValidation && zip === "") setZipError("Zip is Required");
    else setZipError("");
  }, [zip]);
  
  useEffect(() => {
    if (liveValidation && creditLimit === "")
      setCreditlimitError("Creditlimit is Required");
    else setCreditlimitError("");
  }, [creditLimit]);
  useEffect(() => {
    if (liveValidation && limitDays === "")
      setLimitDaysError("limitDays is Required");
    else setLimitDaysError("");
  }, [limitDays]);
  useEffect(() => {
    if (liveValidation && openingDueAmount === "")
      setOpeningdueamountError("Openingdueamount is Required");
    else setOpeningdueamountError("");
  }, [openingDueAmount]);
  useEffect(() => {
    if (liveValidation && dob === "") setDobError("Dob is Required");
    else setDobError("");
  }, [dob]);
  useEffect(() => {
    if (liveValidation && address2 === "")
      setAddress2Error("Address2 is Required");
    else setAddress2Error("");
  }, [address2]);
  useEffect(() => {
    if (liveValidation && city === "") setCityError("City is Required");
    else setCityError("");
  }, [city]);
  useEffect(() => {
    if (liveValidation && secondCustomerName === "")
      setSecondcustomernameError("Secondcustomername is Required");
    else setSecondcustomernameError("");
  }, [secondCustomerName]);
  useEffect(() => {
    if (liveValidation && thirdCustomerName === "")
      setThirdcustomernameError("Thirdcustomername is Required");
    else setThirdcustomernameError("");
  }, [thirdCustomerName]);
  useEffect(() => {
    if (liveValidation && fourthCustomerName === "")
      setFourthcustomernameError("Fourthcustomername is Required");
    else setFourthcustomernameError("");
  }, [fourthCustomerName]);
  useEffect(() => {
    if (liveValidation && anniversary === "")
      setAnniversaryError("Anniversary is Required");
    else setAnniversaryError("");
  }, [anniversary]);
  useEffect(() => {
    if (liveValidation && country === "")
      setCountryError("Country is Required");
    else setCountryError("");
  }, [country]);
 
  useEffect(() => {
    if (liveValidation && secondCustomerContact === "")
      setSecondcustomercontactError("Secondcustomercontact is Required");
    else setSecondcustomercontactError("");
  }, [secondCustomerContact]);
  useEffect(() => {
    if (liveValidation && fourthCustomerContact === "")
      setFourthCustomerContactError("fourthCustomerContact is Required");
    else setFourthCustomerContactError("");
  }, [fourthCustomerContact]);
  useEffect(() => {
    if (liveValidation && thirdCustomerContact === "")
      setThirdcustomercontactError("Thirdcustomercontact is Required");
    else setThirdcustomercontactError("");
  }, [thirdCustomerContact]);*/
  /*CODEGEN_INIT_USE_EFFECT ######## DO_NOT_REMOVE ###########*/

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  async function loadCustomerGroups() {
    let result = await API.get("/api/v1/allcustomergroups");
    populateCustomerGroupOptions(result.data);
  }

  async function loadPricingLevels() {
    let result = await API.get("/api/v1/product/pricing/levels");
    console.log("Pricing Levels", result.data);
    let pricingLevelArray = [];
    let index = 0;
    result.data.map((item) => {
      pricingLevelArray.push({ id: index, name: item });
      index++;
    });
    setPricingLevelOptions(pricingLevelArray);
  }

  function populateCustomerGroupOptions(data) {
    setCustomerGroupOptions([]);
    let dataArray = [{ id: "default", name: "Default" }];
    data.map((item, key) =>
      dataArray.push({ id: item.id, name: item.groupName })
    );
    setCustomerGroupOptions(dataArray);
    console.log("customerGroup fetched: " + JSON.stringify(dataArray));
  }

  function showCustomerCrudWindow(customerId, callFrom) {
    getSaleSettings();
    if (customerId == null) {
      resetFields();
      setMode("create");
      setLiveValidation(false);
      setOpenWindow(true);
      setWindowTitile(translate("New Customer"));
      setCallFrom(callFrom);
    } else {
      setMode(
        props.context.privileges.customer_edit ||
          props.context.privileges.customer_delete
          ? "edit"
          : "view"
      );
      populateCustomer(customerId);
    }
  }
  async function populateCustomer(id) {
    {
      try {
        let { data } = await API.get("/api/v1/customer/" + id);
        setOrigObject(data);
        console.log("original data: " + JSON.stringify(data));
        populateData(data);
        setOpenWindow(true);
      } catch (err) {
        console.error(err);
        props.showMessage(
          "error",
          translate("Not able to retrive Customer data from server")
        );
      }
    }
  }

  function populateData(bean) {
    setName(bean.name);
    setCustid(bean.custId);
    setMicrcode(bean.micrCode);
    setAddress1(bean.address1);
    setState(bean.state);
    setTaxRegistered(bean.taxRegistered);
    setCustomergroup(
      bean.groupId ? { id: bean.groupId, name: bean.groupName } : null
    );

    setPricingLevel(
      bean.pricingLevel && bean.pricingLevelName
        ? { id: bean.pricingLevel, name: bean.pricingLevelName }
        : null
    );

    setStreet(bean.street);
    setZip(bean.zip);
    setTrn(bean.trn);
    setPhone(bean.phone);
    setCreditcustomer(bean.creditCustomer);
    setCreditlimit(bean.creditLimit);
    setLimitDays(bean.limitDays);
    setAddress(bean.address);
    setOpeningdueamount(bean.openingDueAmount);
    setOpeningNature(bean.openingNature ? { name: bean.openingNature } : null);
    setDob(bean.dob);
    setAddress2(bean.address2);
    setCity(bean.city);
    setSecondcustomername(bean.secondCustomerName);
    setThirdcustomername(bean.thirdCustomerName);
    setFourthcustomername(bean.fourthCustomerName);
    setAnniversary(bean.anniversary);
    setCountry(bean.country);
    setMobile(bean.mobile);
    setEmail(bean.email);
    setEmailInvoice(bean.emailInvoice);
    setSmsInvoice(bean.smsInvoice);
    setSecondcustomercontact(bean.secondCustomerContact);
    setThirdcustomercontact(bean.thirdCustomerContact);
    setFourthCustomerContact(bean.fourthCustomerContact);
    /*CODEGEN_POPULATE_DATA ######## DO_NOT_REMOVE ###########*/
  }

  function resetFields() {
    setName("");
    setTaxRegistered(false);
    setNameError("");
    setCustid("AUTO");
    setCustidError("");
    setMicrcode("AUTO");
    setMicrcodeError("");
    setAddress1("");
    setAddress1Error("");
    setState("");
    setStateError("");
    setCustomergroup({ id: "default", name: "DEFAULT" });
    setCustomergroupError("");
    setStreet("");
    setStreetError("");
    setZip("");
    setZipError("");
    setTrn("");
    setTrnError("");
    setPhone("");
    setPhoneError("");
    setCreditcustomer(props.context.store.tradingMode ? true : false);
    setCreditlimit(0);
    setCreditlimitError("");
    setLimitDays(0);
    setLimitDaysError("");
    setOpeningdueamount(0);
    setOpeningdueamountError("");
    setOpeningNature("");
    setOpeningNatureError("");
    setDob("");
    setDobError("");
    setAddress("")
    setAddress2("");
    setAddress2Error("");
    setCity("");
    setCityError("");
    setSecondcustomername("");
    setSecondcustomernameError("");
    setThirdcustomername("");
    setThirdcustomernameError("");
    setFourthcustomername("");
    setFourthcustomernameError("");
    setAnniversary("");
    setAnniversaryError("");
    setCountry("");
    setCountryError("");
    setMobile("");
    setMobileError("");
    setEmail("");
    setEmailError("");
    setSmsInvoice(false);
    setSmsInvoiceError("");
    setEmailInvoice(false);
    setEmailInvoiceError("");
    setSecondcustomercontact("");
    setSecondcustomercontactError("");
    setFourthCustomerContact("");
    setFourthCustomerContactError("");
    setThirdcustomercontact("");
    setThirdcustomercontactError("");
    /*CODEGEN_RESET_FIELDS ######## DO_NOT_REMOVE ###########*/
  }

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  function onCloseWindow() {
    if (callFrom == "trading_screen") {
      props.setShowCustomerCrud(false);
      setOpenWindow(false);
    } else {
      setOpenWindow(false);
    }
  }

  function onDelete() {
    setConfirmOpen(true);
    setConfirmContext({
      title: translate("Are You Sure"),
      message:
        translate("Are you sure to delete customer") +
        " :" +
        origObject.name +
        " ?",
      type: "warning",
      open: true,
      yes: true,
      no: true,
    });
  }
  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      try {
        let result = await API.delete("/api/v1/customer/" + origObject.id);
        props.showMessage("warning", "Customer " + name + " got Removed");
        props.onRefresh();
        setOpenWindow(false);
      } catch (err) {
        props.showMessage("error", translate("Not able to Delete Customer"));
      }
    }
  }
  async function onSave() {
    if (validate()) {
      var payload = createPayload();
      console.log("payload create : " + JSON.stringify(payload));
      try {
        showProgress(true, "Saving");
        let result = await API.post("/api/v1/customer", payload);
        props.showMessage("success", translate("Saved Successfully"));
        if (callFrom == "trading_screen") {
          onCloseWindow();
        } else {
          setMode(props.context.privileges.customer_edit ? "edit" : "view");
          SyncUtils.requestSync(result.headers);
          props.onRefresh();
          populateData(result.data);
          setOrigObject(result.data);
        }
        showProgress(false, "Saving");
      } catch (err) {
        showProgress(false, "Saving");
        if (err.response && err.response.status == 412) {
          showDetailedError(err.response.data);
        } else {
          props.showMessage("error", translate("Not able to Save Customer"));
        }
      }
    }
  }
  function showDetailedError(msg) {
    for (var i = 0; i < msg.messageList.length; i++) {
      var obj = msg.messageList[i];
      if (obj.field === "name") {
        setNameError(obj.message);
      }
      if (obj.field === "custId") {
        setCustidError(obj.message);
      }
      if (obj.field === "micrCode") {
        setMicrcodeError(obj.message);
      }
      if (obj.field === "address1") {
        setAddress1Error(obj.message);
      }
      if (obj.field === "state") {
        setStateError(obj.message);
      }
      if (obj.field === "customerGroup") {
        setCustomergroupError(obj.message);
      }
      if (obj.field === "street") {
        setStreetError(obj.message);
      }
      if (obj.field === "zip") {
        setZipError(obj.message);
      }
      if (obj.field === "trn") {
        setTrnError(obj.message);
      }
      if (obj.field === "phone") {
        setPhoneError(obj.message);
      }
      if (obj.field === "creditLimit") {
        setCreditlimitError(obj.message);
      }
      if (obj.field === "limitDays") {
        setLimitDaysError(obj.message);
      }
      if (obj.field === "openingDueAmount") {
        setOpeningdueamountError(obj.message);
      }
      if (obj.field === "dob") {
        setDobError(obj.message);
      }
      if (obj.field === "address2") {
        setAddress2Error(obj.message);
      }
      if (obj.field === "city") {
        setCityError(obj.message);
      }
      if (obj.field === "secondCustomerName") {
        setSecondcustomernameError(obj.message);
      }
      if (obj.field === "thirdCustomerName") {
        setThirdcustomernameError(obj.message);
      }
      if (obj.field === "fourthCustomerName") {
        setFourthcustomernameError(obj.message);
      }
      if (obj.field === "anniversary") {
        setAnniversaryError(obj.message);
      }
      if (obj.field === "country") {
        setCountryError(obj.message);
      }
      if (obj.field === "mobile") {
        setMobileError(obj.message);
      }
      if (obj.field === "email") {
        setEmailError(obj.message);
      }
      if (obj.field === "secondCustomerContact") {
        setSecondcustomercontactError(obj.message);
      }
      if (obj.field === "fourthCustomerContact") {
        setFourthCustomerContactError(obj.message);
      }
      if (obj.field === "thirdCustomerContact") {
        setThirdcustomercontactError(obj.message);
      }
      /*CODEGEN_DETAILED_ERROR ######## DO_NOT_REMOVE ###########*/
    }
    props.showMessage("error", msg.message);
  }

  function createPayload() {
    let saveObject = Object.create(null);
    console.log(mode);
    saveObject["name"] = name;
    saveObject["custId"] = custId;
    saveObject["micrCode"] = micrCode;
    saveObject["address1"] = address1;
    saveObject["state"] = state;
    saveObject["taxRegistered"] = taxRegistered;
    if (customerGroup) {
      saveObject["groupName"] = customerGroup.name;
      saveObject["groupId"] = customerGroup.id;
    }
    saveObject["street"] = street;
    saveObject["zip"] = zip;
    saveObject["trn"] = trn;
    saveObject["phone"] = phone;
    saveObject["creditCustomer"] = creditCustomer;
    if (creditCustomer) {
      let cLimit = creditLimit == "" || creditLimit == null ? 0 : creditLimit;
      let opDue =
        openingDueAmount == "" || openingDueAmount == null
          ? 0
          : openingDueAmount;

      saveObject["creditLimit"] = cLimit;
      saveObject["limitDays"] =
        limitDays == "" || limitDays == null ? 0 : limitDays;

      saveObject["openingDueAmount"] = opDue;
      saveObject["dueAmount"] = opDue;
      saveObject["openingNature"] = openingNature ? openingNature.name : null;
      saveObject["availableCreditLimit"] = Number(cLimit) - Number(opDue);
    }
    saveObject["address"]=address
    saveObject["dob"] = dob;
    saveObject["address2"] = address2;
    saveObject["city"] = city;
    saveObject["secondCustomerName"] = secondCustomerName;
    saveObject["thirdCustomerName"] = thirdCustomerName;
    saveObject["fourthCustomerName"] = fourthCustomerName;
    saveObject["anniversary"] = anniversary;
    saveObject["country"] = country;
    saveObject["mobile"] = mobile;
    saveObject["email"] = email;
    saveObject["emailInvoice"] = emailInvoice;
    saveObject["smsInvoice"] = smsInvoice;
    saveObject["secondCustomerContact"] = secondCustomerContact;
    saveObject["thirdCustomerContact"] = thirdCustomerContact;
    saveObject["fourthCustomerContact"] = fourthCustomerContact;
    saveObject["pricingLevelName"] = pricingLevel ? pricingLevel.name : null;
    saveObject["pricingLevel"] = pricingLevel ? pricingLevel.id : null;
    /*CODEGEN_CREATE_PAYLOAD ######## DO_NOT_REMOVE ###########*/
    if (mode == "create") {
      saveObject["id"] = null;
      saveObject["intVersion"] = 0;
    }
    if (mode == "edit") {
      saveObject["id"] = origObject.id;
      saveObject["intVersion"] = origObject.intVersion;
    }
    return saveObject;
  }

  async function getSaleSettings() {
    let val = await db.setting.where("sKey").equals("sale").toArray();
    setSaleSettings(JSON.parse(val[0].sValue));
  }

  function validate() {
    let flag = true;
    if (!name || name === "") {
      setNameError(translate("Name is Required"));
      flag = false;
    }
    if (!custId || custId === "") {
      setCustidError(translate("Customer id is Required"));
      flag = false;
    }

    if (!mobile || mobile === "") {
      setMobileError(translate("Mobile number is Required"));
      flag = false;
    }
    if (!customerGroup || customerGroup === "") {
      setCustomergroupError(translate("Customer group is Required"));
      flag = false;
    }
    if (creditCustomer) {
      if (saleSettings.creditLimitOverride && Number(creditLimit) <= 0) {
        setCreditlimitError(translate("Credit limit is Required"));
        flag = false;
      }
      if (saleSettings.limitDaysOverride && Number(limitDays) <= 0) {
        setLimitDaysError(translate("Limit Days Required"));
        flag = false;
      }
      if (saleSettings.creditLimitOverride && Number(openingDueAmount) < 0) {
        setOpeningdueamountError(translate("Opening due amount is Required"));
        flag = false;
      }
      if (Number(openingDueAmount) > Number(creditLimit)) {
        setOpeningdueamountError(translate("Should not exeed credit limit"));
        flag = false;
      }
      if (
        Number(openingDueAmount) > 0 &&
        (openingNature === "" ||
          openingNature == undefined ||
          openingNature == null)
      ) {
        setOpeningNatureError(translate("Opening nature required"));
        flag = false;
      }
    }
    if (emailInvoice && (!email || email === "")) {
      setEmailError(translate("Email Required"));
      flag = false;
    }
    if (taxRegistered && (!trn || trn === "")) {
      setTrnError(translate("Trn Required"));
      flag = false;
    }

    /*
    if (!micrCode || micrCode === "") {
      setMicrcodeError("Micrcode is Required");
      flag = false;
    }
    if (!address1 || address1 === "") {
      setAddress1Error("Address1 is Required");
      flag = false;
    }
    if (!state || state === "") {
      setStateError("State is Required");
      flag = false;
    }
     if (!trn || trn === "") {
      setTrnError("Trn is Required");
      flag = false;
    }
  
    if (!street || street === "") {
      setStreetError("Street is Required");
      flag = false;
    }
    if (!zip || zip === "") {
      setZipError("Zip is Required");
      flag = false;
    }
   
    if (!creditLimit || creditLimit === "") {
      setCreditlimitError("Creditlimit is Required");
      flag = false;
    }
    if (!limitDays || limitDays === "") {
      setLimitDaysError("limitDays is Required");
      flag = false;
    }
    if (!openingDueAmount || openingDueAmount === "") {
      setOpeningdueamountError("Openingdueamount is Required");
      flag = false;
    }
     if (!phone || phone === "") {
      setPhoneError("Phone is Required");
      flag = false;
    }
    if (!dob || dob === "") {
      setDobError("Dob is Required");
      flag = false;
    }
    if (!address2 || address2 === "") {
      setAddress2Error("Address2 is Required");
      flag = false;
    }
    if (!city || city === "") {
      setCityError("City is Required");
      flag = false;
    }
    if (!secondCustomerName || secondCustomerName === "") {
      setSecondcustomernameError("Secondcustomername is Required");
      flag = false;
    }
    if (!thirdCustomerName || thirdCustomerName === "") {
      setThirdcustomernameError("Thirdcustomername is Required");
      flag = false;
    }
    if (!fourthCustomerName || fourthCustomerName === "") {
      setFourthcustomernameError("Fourthcustomername is Required");
      flag = false;
    }
    if (!anniversary || anniversary === "") {
      setAnniversaryError("Anniversary is Required");
      flag = false;
    }
    if (!country || country === "") {
      setCountryError("Country is Required");
      flag = false;
    }
   
    if (!secondCustomerContact || secondCustomerContact === "") {
      setSecondcustomercontactError("Secondcustomercontact is Required");
      flag = false;
    }
    if (!fourthCustomerContact || fourthCustomerContact === "") {
      setFourthCustomerContactError("fourthCustomerContact is Required");
      flag = false;
    }
    if (!thirdCustomerContact || thirdCustomerContact === "") {
      setThirdcustomercontactError("Thirdcustomercontact is Required");
      flag = false;
    }*/
    /*CODEGEN_VALIDATE ######## DO_NOT_REMOVE ###########*/
    if (!flag) {
      setLiveValidation(true);
    }
    return flag;
  }

  const customerDetail1 = (
    <Grid container spacing={3} style={{ height: 365 }}>
      <Grid item xs={12} sm={6}>
        <table width="100%">
          <tbody>
            <tr>
              <td>
                <Typography variant="body1">{translate("Id")}</Typography>
              </td>
              <td>
                <PText
                  value={custId}
                  error={custIdError}
                  disabled={true}
                  onChange={(e) => setCustid(e.target.value)}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">{translate("Name")}</Typography>
              </td>
              <td>
                <PText
                  value={name}
                  error={nameError}
                  onChange={(e) => setName(e.target.value)}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">{translate("Address")}</Typography>
              </td>
              <td>
                <PText
                  value={address}
                  error={addressError}
                  onChange={(e) => setAddress(e.target.value)}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">{translate("Mobile")}</Typography>
              </td>
              <td>
                <PText
                  type="number"
                  value={mobile}
                  error={mobileError}
                  onChange={(e) => setMobile(e.target.value)}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">{translate("Email")}</Typography>
              </td>
              <td>
                <PText
                  type="email"
                  value={email}
                  error={emailError}
                  onChange={(e) => setEmail(e.target.value)}
                ></PText>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                <PCheck
                  onChange={(value) => {
                    setEmailInvoice(value);
                  }}
                  checked={emailInvoice}
                  label={translate("Email Invoice")}
                ></PCheck>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                <PCheck
                  onChange={(value) => {
                    setSmsInvoice(value);
                  }}
                  checked={smsInvoice}
                  label={translate("SMS Invoice")}
                ></PCheck>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">{translate("Group")}</Typography>
              </td>
              <td>
                <PSelect
                  options={customerGroupOptions}
                  value={customerGroup}
                  errorMessage={customerGroupError}
                  onChange={(event, newValue) => {
                    setCustomergroup(newValue);
                  }}
                ></PSelect>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">
                  {translate("Micr Code")}
                </Typography>
              </td>
              <td>
                <Grid container direction="row" spacing={3}>
                  <Grid item xs={12} sm={10}>
                    <PText
                      value={micrCode}
                      error={micrCodeError}
                      onChange={(e) => setMicrcode(e.target.value)}
                    ></PText>
                  </Grid>
                  <Grid item xs={12} sm={2} mt={1}>
                    <PrintIcon />
                  </Grid>
                </Grid>
              </td>
            </tr>
            {/*CODEGEN_REACT_COMPONENT ######## DO_NOT_REMOVE ###########*/}
          </tbody>
        </table>
      </Grid>
      <Grid item xs={12} sm={6}>
        <table width="100%">
          <tbody>
            <tr>
              <td></td>
              <td>
                <PCheck
                  onChange={(value) => {
                    setTaxRegistered(value);
                  }}
                  checked={taxRegistered}
                  label={translate("Tax Registered")}
                ></PCheck>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">{translate("Trn")}</Typography>
              </td>
              <td>
                <PText
                  value={trn}
                  error={trnError}
                  onChange={(e) => setTrn(e.target.value)}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">
                  {translate("Pricing Level")}
                </Typography>
              </td>
              <td>
                <PSelect
                  options={pricingLevelOptions}
                  value={pricingLevel}
                  placeholder={translate("Select...")}
                  //errorMessage={customerGroupError}
                  onChange={(event, newValue) => {
                    setPricingLevel(newValue);
                  }}
                ></PSelect>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                <PCheck
                  onChange={(value) => {
                    setCreditcustomer(value);
                    setLimitDaysError("");
                    setCreditlimitError("");
                    setOpeningdueamountError("");
                  }}
                  checked={creditCustomer}
                  label={translate("A/R Customer")}
                ></PCheck>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">
                  {translate("Credit Amount Limit")}
                </Typography>
              </td>
              <td>
                <PText
                  disabled={!creditCustomer}
                  value={creditLimit}
                  error={creditLimitError}
                  onChange={(e) => {
                    setCreditlimit(e.target.value);
                    setCreditlimitError("");
                  }}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">
                  {translate("Credit Day Limit")}
                </Typography>
              </td>
              <td>
                <PText
                  type="number"
                  disabled={!creditCustomer}
                  value={limitDays}
                  error={limitDaysError}
                  onChange={(e) => {
                    setLimitDays(e.target.value);
                    setLimitDaysError("");
                  }}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">
                  {translate("Opening Amount")}
                </Typography>
              </td>
              <td>
                <PText
                  disabled={!creditCustomer || mode === "edit"}
                  value={openingDueAmount}
                  error={openingDueAmountError}
                  onChange={(e) => setOpeningdueamount(e.target.value)}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">
                  {translate("Opening Nature")}
                </Typography>
              </td>
              <td>
                <PSelect
                  disabled={!creditCustomer || mode === "edit"}
                  options={[
                    { id: "CREDIT", name: "CREDIT" },
                    { id: "DEBIT", name: "DEBIT" },
                  ]}
                  placeholder={translate("Select...")}
                  value={openingNature}
                  errorMessage={openingNatureError}
                  onChange={(event, newValue) => {
                    setOpeningNature(newValue);
                    console.log("1062>>", newValue);
                  }}
                ></PSelect>
              </td>
            </tr>
          </tbody>
        </table>
      </Grid>
    </Grid>
  );

  const customerDetail2 = (
    <Grid container spacing={3} style={{ height: 260 }}>
      <Grid item xs={12} sm={6}>
        <table width="100%">
          <tbody>
            <tr>
              <td>
                <Typography variant="body1">
                  {translate("Address 1")}
                </Typography>
              </td>
              <td>
                <PText
                  value={address1}
                  error={address1Error}
                  onChange={(e) => setAddress1(e.target.value)}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">{translate("Street")}</Typography>
              </td>
              <td>
                <PText
                  value={street}
                  error={streetError}
                  onChange={(e) => setStreet(e.target.value)}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">{translate("Zip")}</Typography>
              </td>
              <td>
                <PText
                  value={zip}
                  error={zipError}
                  onChange={(e) => setZip(e.target.value)}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">{translate("City")}</Typography>
              </td>
              <td>
                <PText
                  value={city}
                  error={cityError}
                  onChange={(e) => setCity(e.target.value)}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">{translate("State")}</Typography>
              </td>
              <td>
                <PText
                  value={state}
                  error={stateError}
                  onChange={(e) => setState(e.target.value)}
                ></PText>
              </td>
            </tr>

            <tr>
              <td>
                <Typography variant="body1">
                  {translate("Date of Birth")}
                </Typography>
              </td>
              <td>
                <PText
                  value={dob}
                  error={dobError}
                  onChange={(e) => setDob(e.target.value)}
                ></PText>
              </td>
            </tr>

            <tr>
              <td>
                <Typography variant="body1">
                  {translate("Address 2")}
                </Typography>
              </td>
              <td>
                <PText
                  value={address2}
                  error={address2Error}
                  onChange={(e) => setAddress2(e.target.value)}
                ></PText>
              </td>
            </tr>
          </tbody>
        </table>
      </Grid>
      <Grid item xs={12} sm={6}>
        <table width="100%">
          <tbody>
            {/*<tr>
              <td>
                <Typography variant="body1">Anniversary</Typography>
              </td>
              <td>
                <PText
                  value={anniversary}
                  error={anniversaryError}
                  onChange={(e) => setAnniversary(e.target.value)}
                ></PText>
              </td>
            </tr>*/}

            <tr>
              <td>
                <Typography variant="body1">{translate("Phone")}</Typography>
              </td>
              <td>
                <PText
                  value={phone}
                  error={phoneError}
                  onChange={(e) => setPhone(e.target.value)}
                ></PText>
              </td>
            </tr>

            <tr>
              <td>
                <Typography variant="body1">
                  {translate("Second Customer Name")}
                </Typography>
              </td>
              <td>
                <PText
                  value={secondCustomerName}
                  error={secondCustomerNameError}
                  onChange={(e) => setSecondcustomername(e.target.value)}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">
                  {translate("Third Customer Name")}
                </Typography>
              </td>
              <td>
                <PText
                  value={thirdCustomerName}
                  error={thirdCustomerNameError}
                  onChange={(e) => setThirdcustomername(e.target.value)}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">
                  {translate("Fourth Customer Name")}
                </Typography>
              </td>
              <td>
                <PText
                  value={fourthCustomerName}
                  error={fourthCustomerNameError}
                  onChange={(e) => setFourthcustomername(e.target.value)}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">
                  {translate("Second Customer Contact")}
                </Typography>
              </td>
              <td>
                <PText
                  value={secondCustomerContact}
                  error={secondCustomerContactError}
                  onChange={(e) => setSecondcustomercontact(e.target.value)}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">
                  {translate("Third Customer Contact")}
                </Typography>
              </td>
              <td>
                <PText
                  value={thirdCustomerContact}
                  error={thirdCustomerContactError}
                  onChange={(e) => setThirdcustomercontact(e.target.value)}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">
                  {translate("Fourth Customer Contact")}
                </Typography>
              </td>
              <td>
                <PText
                  value={fourthCustomerContact}
                  error={fourthCustomerContactError}
                  onChange={(e) => setFourthCustomerContact(e.target.value)}
                ></PText>
              </td>
            </tr>
          </tbody>
        </table>
      </Grid>
    </Grid>
  );
  const customerDetail3 = (
    <Grid container spacing={3} style={{ height: 260 }}>
      <Grid item xs={12} sm={6}>
        <table></table>
      </Grid>
    </Grid>
  );

  const content = (
    <div>
      <Tabs value={value} onChange={handleChange}>
        <Tab label={translate("Basic Details")} />
        <Tab label={translate("More Details")} />
      </Tabs>

      <TabPanel value={value} index={0}>
        {customerDetail1}
      </TabPanel>
      <TabPanel value={value} index={1}>
        {customerDetail2}
      </TabPanel>
    </div>
  );

  function isDataChanged() {
    console.log(name, name || name != "");
    if (mode === "create") {
      if (name || name != "") {
        console.log("Name Chage Detected");
        return true;
      }
      if (micrCode && micrCode != "AUTO") {
        console.log("micrCode");
        return true;
      }
      if (state || state != "") return true;
      if (address1 || address1 != "") return true;
      if (customerGroup.name != "DEFAULT") return true;
      if (street || street != "") return true;
      if (zip || zip != "") return true;
      if (trn || trn != "") return true;
      if (phone || phone != "") return true;
      if (creditCustomer) return true;
      if (creditLimit || creditLimit != "") return true;
      if (limitDays || limitDays != "") return true;
      if (openingDueAmount || openingDueAmount != "") return true;
      if (dob || dob != "") return true;
      if (address2 || address2 != "") return true;
      if (city || city != "") return true;
      if (secondCustomerName || secondCustomerName != "") return true;
      if (thirdCustomerName || thirdCustomerName != "") return true;
      if (fourthCustomerName || fourthCustomerName != "") return true;
      if (anniversary || anniversary != "") return true;
      if (country || country != "") return true;
      if (mobile || mobile != "") return true;
      if (secondCustomerContact || secondCustomerContact != "") return true;
      if (thirdCustomerContact || thirdCustomerContact != "") return true;
      if (fourthCustomerContact || fourthCustomerContact != "") return true;
    }
    if (mode === "edit") {
      if (name !== origObject.name) return true;
      else if (micrCode !== origObject.micrCode) return true;
      else if (state !== origObject.state) return true;
      else if (address1 !== origObject.address1) return true;
      else if (customerGroup && customerGroup.id !== origObject.groupId)
        return true;
      else if (street !== origObject.street) return true;
      else if (zip !== origObject.zip) return true;
      else if (trn !== origObject.trn) return true;
      else if (phone !== origObject.phone) return true;
      else if (creditCustomer !== origObject.creditCustomer) return true;
      else if (creditLimit !== origObject.creditLimit) return true;
      else if (limitDays !== origObject.limitDays) return true;
      else if (openingDueAmount !== origObject.openingDueAmount) return true;
      else if (dob !== origObject.dob) return true;
      else if (address2 !== origObject.address2) return true;
      else if (city !== origObject.city) return true;
      else if (secondCustomerName !== origObject.secondCustomerName)
        return true;
      else if (thirdCustomerName !== origObject.thirdCustomerName) return true;
      else if (fourthCustomerName !== origObject.fourthCustomerName)
        return true;
      else if (secondCustomerContact !== origObject.secondCustomerContact)
        return true;
      else if (thirdCustomerContact !== origObject.thirdCustomerContact)
        return true;
      else if (fourthCustomerContact !== origObject.fourthCustomerContact)
        return true;
      else if (anniversary !== origObject.anniversary) return true;
      else if (country !== origObject.country) return true;
      else if (mobile !== origObject.mobile) return true;
    }
    /*CODEGEN_DATA_CHANGE_DETECTION ######## DO_NOT_REMOVE ###########*/
    return false;
  }
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"md"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          mode={mode}
          isDataChanged={isDataChanged}
          hideSave={
            (!props.context.privileges.customer_edit &&
              props.context.privileges.customer_delete) ||
              mode === "view"
              ? mode === "create"
                ? false
                : true
              : false
          }
          onDelete={props.context.privileges.customer_delete ? onDelete : false}
        ></PDialog>
      )}

      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );
}
